import documentEditorActionCreators from "Areas/Documents/documentEditorPanel/redux/actionCreators";
import sidebarActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getActiveDocumentId, getActiveDocumentType, getDocuments, getProjectId, getSelectedDocumentIds } from "Areas/Sidebar/Documents/redux/selectors";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getFinalReadOnlyMode } from "../redux/getReadOnlyMode";
import ActionPanel from "./actionPanel";
const canEditDocuments = security.isAllowed([Permissions.DocumentsEdit]);
const mapStateToProps = (state) => ({
    projectId: getProjectId(state),
    selectedDocumentIds: getSelectedDocumentIds(state),
    activeDocumentId: getActiveDocumentId(state),
    documentType: getActiveDocumentType(state),
    documents: getDocuments(state),
    canEditDocuments,
    readOnlyMode: getFinalReadOnlyMode(state)
});
const mapDispatchToProps = (dispatch) => ({
    onCloseDocument: (documentId) => dispatch(sidebarActionCreators.setDocumentSelected(documentId, false)),
    onSetDocumentActive: (documentId) => dispatch(sidebarActionCreators.setDocumentSelected(documentId, true)),
    onChangeDocumentType: (documentId, selectedType) => dispatch(sidebarActionCreators.setDocumentType(documentId, selectedType)),
    onOpenDocumentCreatorPanel: (projectId) => dispatch(documentEditorActionCreators.setCreateNewDocument(projectId)),
    onSetReadOnlyMode: (documentId, readOnlyMode) => dispatch(actionCreators.setReadOnlyMode(documentId, readOnlyMode))
});
export default connect(mapStateToProps, mapDispatchToProps)(ActionPanel);
